import React from 'react';
import PlanToolbar from '../PlanToolbar';
import type { PlanAppMode, PlanningSelectionInfo, PlanningActionType } from '../../../types/planManagement';
import type { GridSelectionRect } from './types';

interface PlanEditorModeToolbarProps {
  appMode: PlanAppMode;
  isBusy: boolean;
  allowBedSelection: boolean;
  disablePlanningMode: boolean;
  disablePlantingMode: boolean;
  disableManagementMode: boolean;
  planningSelection: PlanningSelectionInfo | null;
  selectionRect: GridSelectionRect | null;
  isEraseMode: boolean;
  multiSelectedBeds: Set<string>;
  isBulkPlacementMode: boolean;
  bulkGridDimensions: { rows: number; cols: number } | null;
  onAppModeChange: (mode: PlanAppMode) => void;
  onPlanningAction: (action: PlanningActionType) => void;
  onCancelPlanningSelection: () => void;
  onToggleEraseMode: () => void;
  onOpenBulkPlacementModal: () => void;
  onCancelBulkPlacement: () => void;
  onBatchAction?: () => void;
}

const PlanEditorModeToolbar: React.FC<PlanEditorModeToolbarProps> = (props) => {
  return (
    <PlanToolbar
      appMode={props.appMode}
      isBusy={props.isBusy}
      allowBedSelection={props.allowBedSelection}
      disablePlanningMode={props.disablePlanningMode}
      disablePlantingMode={props.disablePlantingMode}
      disableManagementMode={props.disableManagementMode}
      planningSelection={props.planningSelection}
      selectionRect={props.selectionRect}
      isEraseMode={props.isEraseMode}
      multiSelectedBeds={props.multiSelectedBeds}
      isBulkPlacementMode={props.isBulkPlacementMode}
      bulkGridDimensions={props.bulkGridDimensions}
      onAppModeChange={props.onAppModeChange}
      onPlanningAction={props.onPlanningAction}
      onCancelPlanningSelection={props.onCancelPlanningSelection}
      onToggleEraseMode={props.onToggleEraseMode}
      onOpenBulkPlacementModal={props.onOpenBulkPlacementModal}
      onCancelBulkPlacement={props.onCancelBulkPlacement}
      onBatchAction={props.onBatchAction}
    />
  );
};

export default PlanEditorModeToolbar;
